import { useEffect, useState } from "react";
import { Link, NavLink, useParams, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import useSmoothHorizontalScroll from "use-smooth-horizontal-scroll";
import { GetData, PostData } from "../../services/SendData";
import { getConfigData, removeBaseUrl } from "../../services/Helper";
import BookNowButton from "./../../sections/BookNowButton";
import BreadCrumb from "../BreadCrumb";

export default function HealthCondition() {
    const SCROLL_AMOUNT = 100;
    const { scrollContainerRef, handleScroll, scrollTo, isAtStart, isAtEnd } =
        useSmoothHorizontalScroll();
    const configData = getConfigData();
    const { ServiceName } = useParams();
    const { pathname } = useLocation();

    const [healthConditionList, setHealthConditionList] = useState([]);
    const [healthServiceList, setHealthServiceList] = useState([]);

    const [HelathConditionListApi, HealthServiceListApi] = [
        "/loadData/healthConditionList",
        "/loadData/submitPage/getHealthServiceList",
    ];

    const fetchHelathConditionList = async () => {
        try {
            const response = await GetData(HelathConditionListApi, configData);
            await setHealthConditionList(response?.Items);
        } catch (err) {
            console.log(err);
        }
        return false;
    };

    const fetchHealthServiceList = async () => {
        const refactorServiceName =
            ServiceName && ServiceName.toLowerCase().replaceAll("-", " ");
        try {
            const response = await PostData(
                HealthServiceListApi,
                {
                    senddata: {
                        searchKeyword: refactorServiceName || "",
                    },
                },
                configData
            );
            await setHealthServiceList(response?.data);
        } catch (err) {
            console.log(err);
        }
        return false;
    };

    useEffect(() => {
        fetchHelathConditionList();
    }, []);

    useEffect(() => {
        fetchHealthServiceList();
    }, [ServiceName]);

    // const linkRefactor = (link) => {
    //     return link.toLowerCase().replaceAll(" ", "-");
    // };


    return (
        <div className="MyProfile">
            <section className="breadcrumb-section">
                <Container>
                    <BreadCrumb />
                </Container>
            </section>

            <section className="health-condition-page minheight400">
                <div className="container">
                    <h1 className="page-title">Test by Health Condition</h1>
                    <p>
                        Find tests suited to address your specific health
                        condition
                    </p>

                    {!!healthConditionList?.length  && 
                    <div className="health-condition-filter-container">
                        <button
                            disabled={isAtStart}
                            onClick={() => scrollTo(-SCROLL_AMOUNT)}
                            className="left-btn"
                        >
                            <i className="icon-thin-left"></i>
                        </button>

                        <div className="health-condition-filter">
                            <ul
                                ref={scrollContainerRef}
                                onScroll={handleScroll}
                            >
                                <li>
                                    <Link
                                        to={"/health-condition"}
                                        className={
                                            pathname === "/health-condition"
                                                ? "active"
                                                : ""
                                        }
                                    >
                                        All
                                    </Link>
                                </li>
                                {healthConditionList?.map((item) => {
                                    return (
                                        <li key={item?.HCId}>
                                            <NavLink
                                                to={
                                                    "/health-condition/" + item?.PermaWord
                                                    // linkRefactor(
                                                    //     item?.HealthCondition
                                                    // )
                                                }
                                            >
                                                {item?.HealthCondition}
                                            </NavLink>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        <button
                            disabled={isAtEnd}
                            onClick={() => scrollTo(SCROLL_AMOUNT)}
                            className="right-btn"
                        >
                            <i className="icon-thin-right"></i>
                        </button>
                    </div>
                    }

                    <div className="health-service-container">
                        {healthServiceList.map((service, i) => {
                            return (
                                <div className="health-service-card" key={i}>
                                    <div>
                                    <h2 className="title">
                                    <Link to={removeBaseUrl(service?.PermalinkNew || '')}>
                                            {service?.ServiceName}
                                    </Link> 
                                    {/* <a target="_self" href={removeBaseUrl(service?.PermalinkNew || '')}>
                                            {service?.ServiceName}
                                    </a>  */}
                                    </h2>
                                    <p className="other-text">
                                        <span>Preparation:</span>{" "}
                                         {service?.ServicePreparation}
                                    </p>

                                    {service?.ServiceText ?
                                            <p className="other-text test-organ">
                                               * {service?.ServiceText} 
                                            </p> : null}
                                    </div>
                                    
                                    <div className="price-area">
                                        <p className="price">
                                            ₹ {service?.OfferFees}/-
                                        </p>

                                        <BookNowButton
                                            product={service}
                                            className="health-service-book"
                                        />

                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
